<template>
  <path
    d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM12 16.5002C9.51 16.5002 7.5 14.4902 7.5 12.0002C7.5 9.51018 9.51 7.50018 12 7.50018C14.49 7.50018 16.5 9.51018 16.5 12.0002C16.5 14.4902 14.49 16.5002 12 16.5002ZM12 11.0002C11.45 11.0002 11 11.4502 11 12.0002C11 12.5502 11.45 13.0002 12 13.0002C12.55 13.0002 13 12.5502 13 12.0002C13 11.4502 12.55 11.0002 12 11.0002Z"
  />
</template>
